import React, { useEffect, useState } from "react";
import SideMenu from "react-sidemenu";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import MakeAPICall from "../../../../apiCalls/common";
import appRoutes from "../../../../routes/appRoutes";
import { getTraditionalPrescriptionListAPI, getUnreadForumPostCount, getInitialTickitCountApiRoute } from "../../../../apiRoutes";
import { superAdminMenuItems } from "./superAdminMenuData";
import { adminMenuItems } from "./adminMenuData";
import { supportMenuItems } from "./supportMenuData";
import {
  setForumReadComments,
  setForumReadTopics,
  updateUnreadErxOfflineCount,
  setTicketCount
} from "../../../../reduxStore/actions/serverConstants";

const Sidebar = props => {
    let history = useHistory();
    const [apiCallParams, setApiCallParams] = useState(null);
    const [apiCallParams2, setApiCallParams2] = useState(null);
    const [apiCallParams3, setApiCallParams3] = useState(null);
    // const [totalUnreadMessages, setUnreadMessages] = useState(0);
    // const [totalUnreadPost, setTotalUnreadPost] = useState(0);
    // const [totaleRxOffline, setTotaleRxOffline] = useState(0);

    const [activeMenuItem, setActiveMenuItem] = useState(
        sessionStorage.getItem("currentTab")
            ? sessionStorage.getItem("currentTab")
            : appRoutes.supportChat
    );

    const getPostCount = () => {
        setApiCallParams2({
          reqType: "GET",
          reqUrl: getUnreadForumPostCount,
          params: {},
          successCallback: async res => {
            const {
              unReadCommentsCount = 0,
              unReadReplyCommentsCount = 0,
              count = 0
            } = res.data?.data || {};
            props.setForumReadTopics(count);
            props.setForumReadComments(unReadCommentsCount + unReadReplyCommentsCount);
          },
          failureCallback: err => {
            console.error(err)
          }
        });
    }

    useEffect(() => {
        // get the total unread message after 5 secs interval
        // let chatMsgInterval = setInterval(() => {
        //   let apiCallObj = {
        //     reqType: "GET",
        //     reqUrl: getChats,
        //     params: {},
        //     successCallback: async res => {
        //       if (res.data.data.unreadCount) {
        //         setUnreadMessages(res.data.data.unreadCount);
        //       } else {
        //         setUnreadMessages(0);
        //       }
        //     },
        //     failureCallback: err => {}
        //   };

        //   setApiCallParams(apiCallObj);
        // }, 3000);

        // let unreadPostCountInterval = setInterval(() => {
        //   getPostCount();
        // }, 35000);


        // let unreadErxOfflineInterval = setInterval(() => {
        //   getTraditionalPrescriptionCount();
        // }, 15000);

        sessionStorage.setItem("currentTab", activeMenuItem);

        // on component unmount
        return () => {
            sessionStorage.removeItem("currentTab");
            // clearInterval(chatMsgInterval);
            // clearInterval(unreadPostCountInterval);
            // clearInterval(unreadErxOfflineInterval);
        };
    }, [activeMenuItem]);

    const updateActiveMenuItem = item => {
        setActiveMenuItem(item);
        history.push(item);
    };

    let menuType = adminMenuItems;

    if (props.user && props.user.userType === "SUPER_ADMIN") {
        menuType = superAdminMenuItems;
    }
    if (props.user && props.user.userType === "SUPPORT_STAFF") {
        menuType = supportMenuItems;
    }

    const getTraditionalPrescriptionCount = () => {
        let apiCallObj3 = {
            reqType: "GET",
            reqUrl: getTraditionalPrescriptionListAPI,
            params: {limit: 1, skip: 0},
            successCallback: async res => {
                if (res.data && res.data.data && res.data.data) {
                    props.updateUnreadErxOfflineCount(res.data.data.openTraditionlPrescriptionCount);
                }
            },
            failureCallback: err => {
            }
        };

        setApiCallParams3(apiCallObj3);
    }

  const getInitialTickitCount = () => {
        let apiCallObj3 = {
            reqType: "GET",
            reqUrl: getInitialTickitCountApiRoute,
            params: {limit: 1, skip: 0},
            successCallback: async res => {
              if (res.data && res.data.data) {
                // props.setTicketCount(res.data.data[props.user._id]);
                if (props.user.userType !== "SUPPORT_STAFF") {
                  let count = 0;
                  for (const userId in res.data.data) {
                    count += res.data.data[userId];
                  }
                  props.setTicketCount(count);
                } else {
                  props.setTicketCount(res.data.data[props.user?._id] || 0);
                }
                }
            },
            failureCallback: err => {
            }
        };

        setApiCallParams3(apiCallObj3);
    }

    useEffect(() => {
        getTraditionalPrescriptionCount();
        getPostCount();
        getInitialTickitCount();
    }, []);

    // useEffect(() => {
    //    console.log("Server Constant Changed: ", props.serverConstants);
    // }, [props.serverConstants]);


    function getTopicTitle() {
      return props.serverConstants.forumReadTopics === 1 ? 'Topic': 'Topics'
    }

    function getCommentTitle() {
      return props.serverConstants.forumReadComments === 1 ? 'Comment': 'Comments'
    }
    function getTickets() {
      return props.serverConstants.tickitCounts === 1 ? 'Tickit' : 'Tickits'
    }

    function getForumCommentAndTopicCountTooltip() {
      if (props.serverConstants.forumReadTopics && props.serverConstants.forumReadComments) {
        return `${props.serverConstants.forumReadTopics} ${getTopicTitle()} | ${
          props.serverConstants.forumReadComments} ${getCommentTitle()}`;
      } else if (props.serverConstants.forumReadTopics) {
        return `${props.serverConstants.forumReadTopics} ${getTopicTitle()}` ;
      } else if (props.serverConstants.forumReadComments) {
        return `${props.serverConstants.forumReadComments} ${getCommentTitle()}`;
      } else if (props.serverConstants.tickitCounts) {
        return `${props.serverConstants.tickitCounts} ${getTickets()}`;
      }

      return ''
    }

    function  getForumCommentAndTopicCount() {
      if (props.serverConstants.forumReadTopics && props.serverConstants.forumReadComments) {
        return `${props.serverConstants.forumReadTopics} | ${props.serverConstants.forumReadComments}`;
      } else if (props.serverConstants.forumReadTopics) {
        return `${props.serverConstants.forumReadTopics}`;
      } else if (props.serverConstants.forumReadComments) {
        return `${props.serverConstants.forumReadComments}`;
      } else if (props.serverConstants.tickitCounts) {
        return `${props.serverConstants.tickitCounts}`;
      }

      return ''
    }

    return (
        <div className="sidebar-inn-container position-relative">
            <SideMenu
                items={menuType}
                onMenuItemClick={updateActiveMenuItem}
                activeItem={activeMenuItem}
            /> 
            {props.serverConstants.unreadChatCountAdmin > 0 && (
                <span className="chat-messages-count-sidebar">
          {props.serverConstants.unreadChatCountAdmin}
        </span>
            )}

        {/* <Tooltip target='forumCommentAndTopicCount' placement="top" isOpen={showForumTooltip} autohide={true}  toggle={toggleShowForumTooltip}>
            {getForumCommentAndTopicCountTooltip()}
        </Tooltip>

          {(!!(props.serverConstants.forumReadTopics || props.serverConstants.forumReadComments)) && (
            <span id='forumCommentAndTopicCount' className="unread-posts-count-sidebar">
          {getForumCommentAndTopicCount()}
        </span>
          )} */}

        {/* {!!getForumCommentAndTopicCountTooltip() &&
            <div className="forum-count-with-tooltip">
          <div className="tooltip-custom">
            {getForumCommentAndTopicCount()}
            <span className="tooltiptext">{getForumCommentAndTopicCountTooltip()}</span>
          </div>
        </div>
          } */}

        {
          ((props.serverConstants.forumReadTopics + props.serverConstants.forumReadComments) > 0) ? (
            <div className="forum-count-with-tooltip">
              <div className="tooltip-custom">
                <i className="fas fa-envelope"></i>
              </div>
            </div>
          ) : (
            ''
          )
        }
          {props.serverConstants.unreadErxOfflineCount > 0 && (
                    <span className="eRx-Offline-count">
            {props.serverConstants.unreadErxOfflineCount}
          </span>
                )
            }
          {props.serverConstants.tickitCounts > 0 && (
          <span className="ticket-Offline-count">
            {props.serverConstants.tickitCounts}
          </span>
                )
            }
            <MakeAPICall apiParam={apiCallParams}/>
            <MakeAPICall apiParam={apiCallParams2}/>
            <MakeAPICall apiParam={apiCallParams3}/>
        </div>
    );
};

const mapStateToProps = state => ({
    user: state.auth.user,
    serverConstants: state.serverConstants
});

const mapDispatchToProps = dispatch => ({
    setForumReadTopics: data => dispatch(setForumReadTopics(data)),
    setForumReadComments: data => dispatch(setForumReadComments(data)),
    updateUnreadErxOfflineCount: data => dispatch(updateUnreadErxOfflineCount(data)),
    setTicketCount: data => dispatch(setTicketCount(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
